import { useEffect, useState } from "react";
import { getSegments } from "../services/campaignMeta.api";

export default function SegmentDropdown({ onSelect }) {

  const [segments, setSegments] = useState([]);

  useEffect(() => {
    fetchSegments();
  }, []);

  async function fetchSegments() {
    const res = await getSegments();
    setSegments(res.data);
  }

  return (
    <div>
      <label>Select Segment</label>

      <select onChange={(e) => onSelect(Number(e.target.value))}>
        <option value="">Select Segment</option>

        {segments.map(segment => (
          <option key={segment.id} value={segment.id}>
            {segment.name}
          </option>
        ))}
      </select>
    </div>
  );
}
